var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"even:bg-gray-300 rounded hover:bg-gray-400",class:{ 'cursor-pointer': _vm.clickable },on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }